import React, { useState } from 'react';
import cx from 'classnames';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import Link from '@mui/material/Link';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import PencilIcon from '@mui/icons-material/Edit';
import CheckIcon from '@mui/icons-material/Done';
import TrashIcon from '@mui/icons-material/Delete';

import CrmTextField from './CrmTextField';
import AlertModal from './AlertModal';

const useStyles = makeStyles((theme) =>
  createStyles({
    textField: {
      width: (props) => props.lbWidth,
    },
    labelAndLink: {
      display: 'inline-block',
      width: (props) => props.lbWidth,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    quasiInputLabel: {
      fontSize: '0.75rem',
      fontWeight: 400,
      marginTop: '-2px',
      marginBottom: '8px',
      color: 'rgba(0, 0, 0, 0.55)',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    urlInput: {
      fontSize: '13px',
      // font: "inherit",
    },
    link: {
      cursor: 'pointer',
      fontSize: '13px',
      color: 'currentColor',
    },
    icons: {
      display: 'inline',
      float: 'right',
      marginRight: '4px',
    },
    icon: {
      color: '#999',
      cursor: 'pointer',
    },
    icon1: {
      marginRight: '6px',
    },
    hidden: {
      visibility: 'hidden',
    },
  })
);

/*
  Call with something like
  <WebLinkEditor
    label="Website Link"
    linkBoxWidth="240px"
    initialValue={whatever it's supposed to show before editing}
    clickawayShouleSave={T/F}
    onDelete={() => functionToEliminateTheLink()}
    onNewValue={(newText) => functionToSaveTheNewLink}
  />
*/

export default function WebLinkEditor({
  label,
  linkBoxWidth,
  initialValue,
  clickawayShouleSave,
  onDelete,
  onNewValue,
}) {
  const [text, setText] = useState(initialValue);
  const [editing, setEditing] = useState(text.length === 0);
  const [alertMessage, setAlertMessage] = useState('');

  const styleArgs = { lbWidth: linkBoxWidth };
  const classes = useStyles(styleArgs);

  const validateTextAsUrl = () => {
    const dotLoc = text.lastIndexOf('.');
    if (dotLoc < 1 || dotLoc > text.length - 3) {
      return { valid: false, errorMessage: `Your ${label} entry, '${text}', doesn't look like a valid URL` };
    }
    return { valid: true };
  };

  const stopEditing = () => {
    if (text.length === 0) {
      return;
    }
    const validation = validateTextAsUrl();
    if (validation.valid) {
      setEditing(false);
      onNewValue(text);
    } else {
      setAlertMessage(validation.errorMessage);
    }
  };

  const startEditing = () => {
    setEditing(true);
  };

  const doDelete = () => {
    setText('');
    onDelete();
    setEditing(true);
  };

  const isValid = validateTextAsUrl().valid;
  const icon1ClassNames = cx([classes.icon, classes.icon1, { [classes.hidden]: !isValid }]);

  const slashLoc = text.indexOf('//');
  const bareUri = slashLoc < 0 ? text : text.substring(slashLoc + 2);

  return (
    <div>
      <AlertModal show={!!alertMessage} text={alertMessage} closeFunc={setAlertMessage} />

      <div>
        <ClickAwayListener onClickAway={() => stopEditing()} mouseEvent={editing ? 'onMouseDown' : false}>
          <div>
            <div className={classes.icons}>
              {editing ? (
                <span className={icon1ClassNames} onClick={stopEditing}>
                  <CheckIcon fontSize="small" />
                </span>
              ) : (
                <span className={classes.icon + ' ' + classes.icon1} onClick={startEditing}>
                  <PencilIcon fontSize="small" />
                </span>
              )}
              <span className={classes.icon + ' ' + classes.icon2} onClick={doDelete}>
                <TrashIcon fontSize="small" />
              </span>
            </div>
            {editing ? (
              <CrmTextField
                className={classes.textField}
                label={label}
                inputProps={{ className: classes.urlInput }}
                value={text}
                onChange={(event) => setText(event.target.value.trim())}
              />
            ) : (
              <div className={classes.labelAndLink}>
                <div className={classes.quasiInputLabel}>{label}</div>
                <Link
                  className={classes.link}
                  href={'http://' + bareUri}
                  target="_blank"
                  rel="noopener"
                  underline="hover"
                >
                  {text}
                </Link>
              </div>
            )}
          </div>
        </ClickAwayListener>
      </div>
    </div>
  );
}
